// extracted by css-extract-rspack-plugin
export default {"item":"_cf53876b","desktopDealerItem":"_224860a2","desktopInternalItem":"_52c131be","forceBaseHeight":"_303f9a29","icon":"_410306f5","title":"_ee79d8fe"};